import React from 'react';

import { INSTAGRAM, TIKTOK, YOUTUBE, LINKEDIN } from '@/utils/constants';
import InstagramIcon from './SocialIcons/InstagramIcon';
import TikTokIcon from './SocialIcons/TikTokIcon';
import YouTubeIcon from './SocialIcons/YouTubeIcon';
import LinkedInIcon from './SocialIcons/LinkedInIcon';
import {
  SocialProviderWrapper,
  SocialLinkWrapper,
  SocialLink,
} from './ContactBlock.styles';

const socialMedia = {
  Instagram: {
    link: INSTAGRAM,
    icon: InstagramIcon,
  },
  TikTok: {
    link: TIKTOK,
    icon: TikTokIcon,
  },
  YouTube: {
    link: YOUTUBE,
    icon: YouTubeIcon,
  },
  LinkedIn: {
    link: LINKEDIN,
    icon: LinkedInIcon,
  },
};

type Props = {
  socialProviders: string[];
};

const SocialProviders: React.FC<Props> = (props) => {
  const { socialProviders } = props;

  if (!socialProviders?.length) {
    return null;
  }

  return (
    <SocialProviderWrapper>
      {socialProviders.map((social) => {
        const { link, icon: IconComponent } = socialMedia[social] || {};

        return (
          <SocialLinkWrapper key={social}>
            <SocialLink href={link} target='blank' rel='noopener noreferrer'>
              <IconComponent />
            </SocialLink>
          </SocialLinkWrapper>
        );
      })}
    </SocialProviderWrapper>
  );
};

export default SocialProviders;
